import React from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Button,
  DataTable,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from 'carbon-components-react';
import { CFCProps, SCREEN_SIZE } from 'types';
import { PhoneFilled16 } from '@carbon/icons-react';
import { clearECData } from 'redux/emergencyContacts/actions';
import { clearPlaceSuggest } from 'redux/map/actions';
import UtilityIcon from 'components/UtilityIcons';
import { phoneNumberFormatter } from 'utilities/validation';

const connector = connect();
type Props = CFCProps<typeof connector> & any;

export const ViewEmergencyContacts: React.FC<Props> = (props: Props) => {
  const { ecOrganisations, setShowEC, selectedAddress, screenSize } = props;
  const dispatch: any = useDispatch();
  const handleNewSearch = () => {
    setShowEC(false);
    dispatch(clearECData());
    dispatch(clearPlaceSuggest());
  };

  return (
    <div className="emergency-contact--body-top">
      <div className="emergency-contact--result-page">
        <h2 className="heading--top">Emergency Contacts</h2>
        <p className="heading-description">
          Within a 200m radius of{' '}
          <span className="highlight-location">{selectedAddress}</span>
        </p>
        <div className="emergency-contact--list">
          <DataTable headers={[]} rows={ecOrganisations || []}>
            {({ getTableProps, getRowProps }: any) => {
              return (
                <TableContainer>
                  <Table {...getTableProps()}>
                    <TableBody>
                      {ecOrganisations.map((row: any, idx: any) => {
                        return (
                          <TableRow key={idx} {...getRowProps({ row })}>
                            <TableCell
                              key={'organisationType'}
                              className="utility-icon"
                            >
                              <UtilityIcon type={row['organisationType']} />
                            </TableCell>
                            <TableCell key={'name'}>
                              <div>{row['name']}</div>
                              {[SCREEN_SIZE.SM].includes(screenSize) && (
                                <div>
                                  {phoneNumberFormatter({
                                    phoneNumber: String(
                                      row['contactEmergencyPhone']
                                    )
                                  }).getNationalNumberFormat()}
                                </div>
                              )}
                            </TableCell>
                            {![SCREEN_SIZE.SM].includes(screenSize) && (
                              <TableCell key={'primaryContact'}>
                                <div>
                                  {phoneNumberFormatter({
                                    phoneNumber: String(
                                      row['contactEmergencyPhone']
                                    )
                                  }).getNationalNumberFormat()}
                                </div>
                              </TableCell>
                            )}
                            <TableCell
                              key={'utilityId'}
                              className="utility-icon phone-icon"
                            >
                              <Link
                                href={`tel:${row['contactEmergencyPhone']}`}
                              >
                                <PhoneFilled16 />
                              </Link>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              );
            }}
          </DataTable>
          <div className="emergency-contact--list-new-search">
            <Button kind="primary" onClick={handleNewSearch}>
              New search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

ViewEmergencyContacts.displayName = 'ViewEmergencyContacts';

export default connector(ViewEmergencyContacts);
